import { Toaster } from 'react-hot-toast';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

import { ProtectedRoute } from './components/auth';
import { AdelantosDeNominaPage as AdminAdelantosPage } from './pages/admin/adelantos';
import { AuditPage } from './pages/admin/audit';
import { CompliancePage } from './pages/admin/compliance';
import { Dashboard as AdminDashboard } from './pages/admin/dashboard';
import { EmployeeDirectoryPage, EmployeeDetailPage } from './pages/admin/employees';
import { OnboardingPage } from './pages/admin/onboarding';
import { OperationsCenterPage } from './pages/admin/operations';
import { ReportsPage as AdminReportsPage } from './pages/admin/reports';
import { SettingsPage } from './pages/admin/settings';
import { AdminFunnelPage } from './pages/admin-onboarding/AdminFunnelPage';
import { LoginPage, ResetPasswordPage } from './pages/auth';
import { AdminOnboardingPage } from './pages/auth/AdminOnboardingPage';
import { NotificationsCenter } from './pages/notifications';
import { OperacionesGenerales } from './pages/operaciones';
import { AdelantosDeNomina } from './pages/operaciones/adelantos-de-nomina';
import { PaymentFlow } from './pages/payments';
import { ProfilePage, ConfigurationPage } from './pages/profile';
import { AccountStatementsPage } from './pages/shared/AccountStatementsPage';
import RiskAssessmentPage from './pages/shared/RiskAssessmentPage';
import { RolesPage } from './pages/shared/RolesPage';
import {
  ClientListPage,
  ClientDetailPage,
  ClientEmployeeDetailPage,
  UnregisteredUsersPage,
  UnregisteredUserDetailPage,
} from './pages/super-admin/clients';
import { ConfigReviewPage, OrgConfigPage } from './pages/super-admin/config-review';
import { Dashboard } from './pages/super-admin/dashboard';
import { OnboardingReviewPage, ApplicationDetailPage } from './pages/super-admin/onboarding-review';
import { ReportsPage } from './pages/super-admin/reports';

function App() {
  return (
    <>
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 4000,
          style: {
            background: '#363636',
            color: '#fff',
          },
          success: {
            duration: 3000,
            iconTheme: {
              primary: '#10B981',
              secondary: '#fff',
            },
          },
          error: {
            duration: 4000,
            iconTheme: {
              primary: '#EF4444',
              secondary: '#fff',
            },
          },
        }}
      />
      <Router>
        <Routes>
          {/* Public Routes */}
          <Route
            path="/login"
            element={
              <ProtectedRoute requireAuth={false}>
                <LoginPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/reset-password"
            element={
              <ProtectedRoute requireAuth={false}>
                <ResetPasswordPage />
              </ProtectedRoute>
            }
          />

          {/* Super Admin Routes */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute allowedRoles={['super_admin']}>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/clientes"
            element={
              <ProtectedRoute allowedRoles={['super_admin']}>
                <ClientListPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/clientes/sin-organizacion"
            element={
              <ProtectedRoute allowedRoles={['super_admin']}>
                <UnregisteredUsersPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/clientes/sin-organizacion/:userId"
            element={
              <ProtectedRoute allowedRoles={['super_admin']}>
                <UnregisteredUserDetailPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/clientes/:clientId"
            element={
              <ProtectedRoute allowedRoles={['super_admin']}>
                <ClientDetailPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/clientes/:clientId/empleados/:employeeId"
            element={
              <ProtectedRoute allowedRoles={['super_admin']}>
                <ClientEmployeeDetailPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/operaciones/generales"
            element={
              <ProtectedRoute allowedRoles={['super_admin']}>
                <OperacionesGenerales />
              </ProtectedRoute>
            }
          />
          <Route
            path="/operaciones/adelantos-de-nomina"
            element={
              <ProtectedRoute allowedRoles={['super_admin', 'admin']}>
                <AdelantosDeNomina />
              </ProtectedRoute>
            }
          />
          <Route
            path="/seguridad"
            element={
              <ProtectedRoute allowedRoles={['super_admin']}>
                <RolesPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/reportes"
            element={
              <ProtectedRoute allowedRoles={['super_admin']}>
                <ReportsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/reportes/evaluacion-de-riesgos"
            element={
              <ProtectedRoute allowedRoles={['super_admin', 'admin', 'manager']}>
                <RiskAssessmentPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/reportes/estados-de-cuenta"
            element={
              <ProtectedRoute allowedRoles={['super_admin', 'admin', 'manager']}>
                <AccountStatementsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/notificaciones"
            element={
              <ProtectedRoute allowedRoles={['super_admin', 'admin', 'manager']}>
                <NotificationsCenter />
              </ProtectedRoute>
            }
          />
          <Route
            path="/perfil"
            element={
              <ProtectedRoute allowedRoles={['super_admin', 'admin', 'manager']}>
                <ProfilePage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/configuracion"
            element={
              <ProtectedRoute allowedRoles={['super_admin', 'admin', 'manager']}>
                <ConfigurationPage />
              </ProtectedRoute>
            }
          />

          {/* Admin/Manager Routes */}
          <Route
            path="/dashboard-empresarial"
            element={
              <ProtectedRoute allowedRoles={['admin', 'manager']}>
                <AdminDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/empleados/directorio"
            element={
              <ProtectedRoute allowedRoles={['admin', 'manager']}>
                <EmployeeDirectoryPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/empleados/directorio/:employeeId"
            element={
              <ProtectedRoute allowedRoles={['admin', 'manager']}>
                <EmployeeDetailPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/empleados/onboarding"
            element={
              <ProtectedRoute allowedRoles={['admin', 'manager']}>
                <OnboardingPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/operaciones-empresariales/centro-de-pagos"
            element={
              <ProtectedRoute allowedRoles={['admin', 'manager']}>
                <OperationsCenterPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/configuracion/usuarios-y-roles"
            element={
              <ProtectedRoute allowedRoles={['admin', 'manager']}>
                <RolesPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/reportes/analisis-empresarial"
            element={
              <ProtectedRoute allowedRoles={['admin', 'manager']}>
                <AdminReportsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/operaciones-empresariales/adelantos-de-nomina"
            element={
              <ProtectedRoute allowedRoles={['admin', 'manager']}>
                <AdminAdelantosPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/reportes/auditoria-interna"
            element={
              <ProtectedRoute allowedRoles={['admin', 'manager']}>
                <AuditPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/reportes/cumplimiento"
            element={
              <ProtectedRoute allowedRoles={['admin', 'manager']}>
                <CompliancePage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/configuracion/parametros-empresariales"
            element={
              <ProtectedRoute allowedRoles={['admin', 'manager']}>
                <SettingsPage />
              </ProtectedRoute>
            }
          />

          {/* Payment Routes - Accessible by super_admin and admin/manager */}
          <Route
            path="/pagos"
            element={
              <ProtectedRoute allowedRoles={['super_admin', 'admin', 'manager']}>
                <PaymentFlow />
              </ProtectedRoute>
            }
          />

          {/* Admin Onboarding - Public token-based signup */}
          <Route
            path="/admin-onboarding"
            element={
              <ProtectedRoute requireAuth={false}>
                <AdminOnboardingPage />
              </ProtectedRoute>
            }
          />

          {/* Admin Onboarding Funnel - Authenticated invited admin (no org yet) */}
          <Route
            path="/admin-onboarding/funnel"
            element={
              <ProtectedRoute>
                <AdminFunnelPage />
              </ProtectedRoute>
            }
          />

          {/* Super Admin Onboarding Review */}
          <Route
            path="/clientes/onboarding-review"
            element={
              <ProtectedRoute allowedRoles={['super_admin']}>
                <OnboardingReviewPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/clientes/onboarding-review/:userId"
            element={
              <ProtectedRoute allowedRoles={['super_admin']}>
                <ApplicationDetailPage />
              </ProtectedRoute>
            }
          />

          {/* Super Admin Parameter Change Review */}
          <Route
            path="/clientes/parametros-revision"
            element={
              <ProtectedRoute allowedRoles={['super_admin']}>
                <ConfigReviewPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/clientes/parametros/:organizationId"
            element={
              <ProtectedRoute allowedRoles={['super_admin']}>
                <OrgConfigPage />
              </ProtectedRoute>
            }
          />

          {/* Default Route - Redirect to login */}
          <Route path="/" element={<Navigate to="/login" replace />} />

          {/* Catch all route - Redirect to login */}
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </Router>
    </>
  );
}

export default App;
